// Tests: https://regex101.com/r/dQVXf2/1
/**
 * @param {string} url A URL that may, or may not, be for a Payment Next purchase
 * @returns {string} URL to redirect to
 */
export function getRedirectUrl(url) {
  if (isLegacyPurchaseUrl(url)) {
    const [, id, , queryParams] = url.match(legacyUrlRegexp);
    return ['purchase/', id, queryParams].join('');
  } else {
    return 'purchase/not_found';
  }
}

const legacyUrlRegexp =
  /^(?:#\/)([0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})(\/checkout)?(\?.+)?$/i;

function isLegacyPurchaseUrl(url) {
  return typeof url === 'string' && legacyUrlRegexp.test(url);
}
